export const auraCodeAssets = {
	code: {
		chapters: 'https://remotion.media/why/aura-code/chapters-f35f06795d95.png',
		styles: 'https://remotion.media/why/aura-code/styles-5121083dba37.png',
		captions: 'https://remotion.media/why/aura-code/captions-82783844487c.png',
		duplicate:
			'https://remotion.media/why/aura-code/duplicate-72793d494aed.webm',
	},
	timeline: {
		chapters:
			'https://remotion.media/why/aura-code/timeline/chapters-621ab215cf36.png',
		styles:
			'https://remotion.media/why/aura-code/timeline/styles-b3a1d6c93133.png',
		selection:
			'https://remotion.media/why/aura-code/timeline/selection-bb16c4980379.png',
		captions:
			'https://remotion.media/why/aura-code/timeline/captions-536ebd78e3c2.png',
	},
	score: 'https://remotion.media/why/aura-code/score-6b9f2838fa02.wav',
} as const;
